import EmblaCarousel from 'embla-carousel'
import ClassNames from 'embla-carousel-class-names'

export function carouselInit() {
    // Cleanup existing carousels first
    const existingCarousels = document.querySelectorAll('.hoyry-listing-supports-carousel');
    existingCarousels.forEach((carousel) => {
        const emblaNode = carousel.querySelector('.embla');
        if (emblaNode && emblaNode._embla) {
            emblaNode._embla.destroy();
        }
    });

    const carousels = document.querySelectorAll('.hoyry-listing-supports-carousel');
    carousels.forEach((carousel) => {
        // Check if the element exists and is valid
        if (!carousel || !(carousel instanceof Element)) {
            return;
        }
        
        const emblaViewport = carousel.querySelector('.embla__viewport');
        
        // Early return if no container is found
        if (!emblaViewport) {
            return;
        }

        const prevButton = carousel.querySelector('.hoyry-listing-carousel-arrow-prev');
        const nextButton = carousel.querySelector('.hoyry-listing-carousel-arrow-next');
        const dots = carousel.querySelector('.hoyry-listing-carousel-dots');

        try {
            const emblaApi = new EmblaCarousel(emblaViewport, 
                {
                    loop: false,
                    align: 'start',
                    slidesToScroll: 'auto',
                }, [
                    ClassNames(),
                ]
            );

            // Store the embla instance for cleanup
            emblaViewport._embla = emblaApi;

            const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
                const togglePrevNextBtnsState = () => {
                    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
                    else prevBtn.setAttribute('disabled', 'disabled')
            
                    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
                    else nextBtn.setAttribute('disabled', 'disabled')
                }
            
                emblaApi
                    .on('select', togglePrevNextBtnsState)
                    .on('init', togglePrevNextBtnsState)
                    .on('reInit', togglePrevNextBtnsState)
            
                return () => {
                    prevBtn.removeAttribute('disabled')
                    nextBtn.removeAttribute('disabled')
                }
            }
            
            const addPrevNextBtnsClickHandlers = (emblaApi, prevButton, nextButton) => {
                const scrollPrev = () => {
                    emblaApi.scrollPrev()
                }
                const scrollNext = () => {
                    emblaApi.scrollNext()
                }
                prevButton.addEventListener('click', scrollPrev, false)
                nextButton.addEventListener('click', scrollNext, false)
            
                const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
                    emblaApi,
                    prevButton,
                    nextButton
                )
            
                return () => {
                    removeTogglePrevNextBtnsActive()
                    prevButton.removeEventListener('click', scrollPrev, false)
                    nextButton.removeEventListener('click', scrollNext, false)
                }
            }
            
            const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
                let dots = []
            
                const addDotBtnsWithClickHandlers = () => {
                    dotsNode.innerHTML = emblaApi
                        .scrollSnapList()
                        .map(() => '<button class="hoyry-listing-carousel-dot" type="button"></button>')
                        .join('')
            
                    const scrollTo = (index) => {
                        emblaApi.scrollTo(index)
                    }
            
                    dots = Array.from(dotsNode.querySelectorAll('.hoyry-listing-carousel-dot'))
                    dots.forEach((dot, index) => {
                        dot.addEventListener('click', () => scrollTo(index), false)
                    })
                }
            
                const toggleDotBtnsActive = () => {
                    const previous = emblaApi.previousScrollSnap()
                    const selected = emblaApi.selectedScrollSnap()
                    dots[previous].classList.remove('is-active')
                    dots[selected].classList.add('is-active')
                }
            
                emblaApi
                    .on('init', addDotBtnsWithClickHandlers)
                    .on('reInit', addDotBtnsWithClickHandlers)
                    .on('init', toggleDotBtnsActive)
                    .on('reInit', toggleDotBtnsActive)
                    .on('select', toggleDotBtnsActive)
            
                return () => {
                    dotsNode.innerHTML = ''
                }
            }
            
            // Only initialize navigation if both buttons exist
            if (prevButton && nextButton) {
                const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
                    emblaApi,
                    prevButton,
                    nextButton
                )
                emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
            }

            // Only initialize dots if the dots container exists and is an Element
            if (dots && dots instanceof Element) {
                const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                    emblaApi,
                    dots
                );
                emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
            }
        } catch (error) {
            console.error('Error initializing carousel:', error);
        }
    });
}
  
// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', carouselInit);
} else {
    carouselInit();
}

// Re-initialize on dynamic content changes
document.addEventListener('contentChanged', carouselInit);